export default __webpack_public_path__ + "static/media/remark_shows.da014c3e.png";